import React from "react";
import "./Footer.scss";
import { Fade } from "react-awesome-reveal";

export default function Footer() {
  return <Fade bottom duration={1000} distance="5px"></Fade>;
}
